import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState<number>(0);
  const total = pageSamples.length;
  const goTo = (next: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(total - 1, next));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track || track.clientWidth === 0) return;
    const current = Math.round(track.scrollLeft / track.clientWidth);
    if (current !== index) setIndex(current);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-122" data-mp="3pmybaukmj3ug">
      <div className="mx-auto max-w-5xl" data-id="element-123" data-mp="3kv6hmb668i03">
        <div className="mx-auto max-w-2xl text-center" data-id="element-124" data-mp="3ktdbcwzgzzsm">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-125" data-mp="1mm2wi1znh9gx">
            Sfoglia il materiale
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-126" data-mp="1rknya5ujw17h">
            Guarda le pagine{' '}
            <span className="italic text-brand" data-id="element-127" data-mp="1huks13yf4qr7">dall&apos;interno.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-128" data-mp="13vbl6uw3r8zw">
            Pagine reali del pacchetto, dalle prime attività di 1ª Primaria alle
            infografiche della scuola media.
          </p>
        </div>

        <div ref={trackRef} onScroll={handleScroll} role="group" aria-roledescription="carosello" aria-label="Pagine di esempio del materiale" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      }} className="no-scrollbar mt-10 flex w-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain rounded-3xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-129" data-mp="uwraoh0p45mr">
          {pageSamples.map((page, pageIndex) => <article key={page.src} aria-roledescription="slide" aria-label={`${pageIndex + 1} di ${total}`} className="w-full min-w-0 shrink-0 snap-start" data-id="element-130" data-mp="3t8w6xdb59xqa" data-mpi={pageIndex}>
              <div className="grid gap-6 md:grid-cols-2 md:items-center md:gap-8" data-id="element-131" data-mp="orjs32hgt4j9">
                <div className="relative min-w-0 overflow-hidden rounded-3xl bg-white p-3 shadow-soft sm:p-4" data-id="element-132" data-mp="ksavlpv1isk0">
                  <img src={page.src} alt={`${page.title} — pagina di esempio, ${page.level}`} loading={pageIndex === 0 ? 'eager' : 'lazy'} className="block h-auto w-full rounded-xl" data-id="element-133" data-mp="fz8be8c5kvgh" />
                  <button type="button" onClick={() => goTo(pageIndex - 1)} aria-label="Pagina precedente" className="absolute left-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:left-6" data-id="element-134" data-mp="18hvslco13qca">
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-135" data-mp="1ky4ximvrd9e7" />
                  </button>
                  <button type="button" onClick={() => goTo(pageIndex + 1)} aria-label="Pagina successiva" className="absolute right-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:right-6" data-id="element-136" data-mp="1oyx6df0pxc9y">
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="2cqvtcw9j4w2x" />
                  </button>
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-ink/85 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-138" data-mp="2hp5tzme0wovx">
                    {pageIndex + 1} / {total}
                  </span>
                </div>

                <div className="min-w-0 md:pr-4" data-id="element-139" data-mp="2dt1enc7ot1j0">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-140" data-mp="2duw3h1m2xdsd">
                    {page.level}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-141" data-mp="1l3cet26pr7iz">
                    {page.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-142" data-mp="1v2a8ejizxr8u">
                    {page.caption}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        

        <p className="mt-3 text-center text-xs font-bold tabular-nums text-ink/40" data-id="element-143" data-mp="36h72w8xy98nl">
          {index + 1} / {total}
        </p>
      </div>
    </section>;
}